import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/warningIcon.svg";

const WarningIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default WarningIcon;
